var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend1"},[_c('p',[_c('span',{staticClass:"red"}),_vm._v("\n\t\t"+_vm._s(_vm.myabnormalName)+"\n\t")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"blue"}),_vm._v("\n\t\t"+_vm._s(_vm.mynormalName)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-126893ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/comss/legendOne.vue
// module id = null
// module chunks = 